<template>
  <section class="section section--pagetop">
    <img
      v-if="topPreviewPath"
      :src="useStrapiMediaUrl(topPreviewPath)"
      class="pagetop-preview"
      loading="lazy"
    />
    <div class="pagetop">
      <div class="pagetop__wrapper">
        <div class="pagetop__content">
          <div
            class="text-44 text-bold pagetop__title"
            v-html="content?.name"
          ></div>
          <div class="pagetop__row">
            <img
              v-if="content.icon?.data"
              :src="useStrapiMediaUrl(content.icon.data.attributes.url)"
              class="pagetop__icon"
              loading="lazy"
            />
            <div
              v-if="content.partner?.data?.attributes?.logo?.data?.attributes"
              class="pagetop__partner"
            >
              <p class="text-14 text-bold pagetop__partner__title">
                Партнер номинации:
              </p>
              <NuxtLink
                :to="
                  content.partner.data.attributes.is_ext
                    ? content.partner.data.attributes.ext_link
                    : getPartnerLink(content.partner.data.attributes.slug)
                "
                target="_blank"
              >
                <img
                  :src="
                    useStrapiMediaUrl(
                      content.partner.data.attributes.logo?.data.attributes.url,
                    )
                  "
                  loading="lazy"
                />
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import type { Nomination } from "~/types/strapiContent"

const props = defineProps<{
  content: Nomination
}>()

const topPreviewPath = computed(() => {
  const formats = props.content?.photo?.data?.attributes?.formats

  return (
    formats?.large?.url ??
    formats?.medium?.url ??
    formats?.small?.url ??
    formats?.thumbnail?.url ??
    props.content?.photo?.data?.attributes?.url
  )
})
</script>
<style lang="scss">
.section {
  &--pagetop {
    margin: 0 auto;
    min-height: 100svh;
    max-height: 830px;
    max-width: 1440px;
    display: flex;
    flex-direction: row-reverse;
    @include md {
      max-height: 1070px;
      flex-direction: column-reverse;
      justify-content: center;
    }
  }
}
.pagetop-preview {
  display: block;
  object-fit: cover;
  width: 100%;
  max-width: 710px;
  height: auto;
  align-self: center;
  margin: auto 0;
  position: relative;
  z-index: 0;
//   filter: brightness(50%);
  @include md {
    margin: 90px 0 0 0;
    max-width: 60%;
  }
  @include sm {
    margin: 40px 0 0 0;
  }
}
.pagetop {
  color: $white;

  &__wrapper {
    height: 100%;
    padding: 20% 0 0 0;
    display: flex;

    @include md {
      padding: 20% 36px 0;
    }
    @include sm {
      padding: 30% 16px 0;
    }
  }
  &__content {
    width: 90%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 15vh;
    gap: 4rem;

    @include md {
      width: 100%;
      padding-bottom: 0;
    }
  }
  &__title {
    display: inline-block;
    font-size: 44px;
    line-height: 53px;
    @include md {
      font-size: 32px;
      line-height: 38px;
    }
    @include sm {
      font-size: 24px;
      line-height: 28px;
    }
  }
  &__icon {
    width: 185px;
    height: 112px;
    @include md {
      width: 60px;
      height: 48px;
    }
    // @include sm {
    //   margin: 20px 0 0 0;
    // }
  }
  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 4rem;
  }
  &__partner {
    text-align: right;

    img {
      height: 112px;
      width: auto;
    }
    @include md {
      img {
        height: 48px;
      }
      &__title {
        font-size: 12px;
      }
    }
    @include sm {
      &__title {
        font-size: 10px;
      }
    }
  }
}
</style>
